import { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import Iconify from 'src/components/Iconify';

interface TagRowActionsProps {
  tagId: string;
  onEdit: (tagId: string) => void;
  onView: (tagId: string) => void;
}

export default function TagRowActions({ tagId, onEdit, onView }: TagRowActionsProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <Iconify icon="eva:more-vertical-fill" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={handleClose}>
        <MenuItem onClick={() => { onView(tagId); handleClose(); }}>
          View Details
        </MenuItem>
        <MenuItem onClick={() => { onEdit(tagId); handleClose(); }}>
          Edit
        </MenuItem>
      </Menu>
    </>
  );
}

